module.exports = __webpack_public_path__ + "static/media/RoboGarcon.6fd0e60a.svg";